import { render, staticRenderFns } from "./CDC-Detail.vue?vue&type=template&id=95963de2&scoped=true"
import script from "./CDC-Detail.vue?vue&type=script&lang=js"
export * from "./CDC-Detail.vue?vue&type=script&lang=js"
import style0 from "./CDC-Detail.vue?vue&type=style&index=0&id=95963de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95963de2",
  null
  
)

export default component.exports